import { useEffect, useMemo } from 'react';
import throttle from 'lodash.throttle';

const useThrottle = <T extends (...args: any) => any>(fn: T, ms = 300) => {
  const callback = useMemo(() => throttle(fn, ms), [fn, ms]);
  useEffect(() => callback.cancel, [callback]);
  return callback;
};

export default useThrottle;
